import type { Envelope } from './types';
const unauthenticatedListeners = new Set<() => void>();
export const apiEvents = {
  onUnauthenticated(listener: () => void) {
    unauthenticatedListeners.add(listener);
    return () => { unauthenticatedListeners.delete(listener); };
  },
};
export class ApiError extends Error {
  constructor(public readonly code: string, public readonly status: number | null = null) { super(code); }
}
export async function apiGet<T>(path: string, signal?: AbortSignal): Promise<T> {
  let response: Response;
  try {
    response = await fetch(path, { credentials: 'same-origin', signal: AbortSignal.any([...(signal ? [signal] : []), AbortSignal.timeout(15_000)]) });
  } catch (error) {
    if (signal?.aborted) throw error;
    throw new ApiError(navigator.onLine === false ? 'network_offline' : error instanceof DOMException && error.name === 'TimeoutError' ? 'timeout' : 'server_unreachable');
  }
  let body: Envelope<T>;
  try { body = await response.json() as Envelope<T>; } catch { throw new ApiError(response.status >= 500 ? 'server_error' : 'bad_response', response.status); }
  if (!body || typeof body !== 'object' || typeof body.ok !== 'boolean' || typeof body.code !== 'string' || !('data' in body)) throw new ApiError('bad_response',response.status);
  if (!response.ok || !body.ok) {
    if (response.status === 401 && body.code === 'unauthenticated') unauthenticatedListeners.forEach(listener => listener());
    throw new ApiError(body.code,response.status);
  }
  return body.data;
}
export const retryRead = (count: number, error: unknown) => count < 2 && error instanceof ApiError && ['timeout','server_unreachable','server_error','data_loading'].includes(error.code);
